<template>
  <div class="infowrapper">
    <section class="flex mb16 two"
             v-if="pageData && pageData.firstLine">
      <div class="item" v-for="(item,index) in pageData.firstLine" :key="'keyL'+index">
        <div class="top">
          <div class="text">{{item.name}}</div>
          <div class="icon" v-if="item.desc">
            <Tooltip  style="width: 100%;height: 100%">
              <Icon type="ios-help-outline"></Icon>
              <div slot="content" style="white-space: normal">
                {{item.desc}}
              </div>
            </Tooltip>
          </div>
        </div>

        <div :class="['value',]">
          <div class="text color-main">{{item.value}}</div>
          <div class="icon" v-if="item.itemList && item.itemList.length">
            <tip>
              <span>
                <p v-for="(item1,index1) in item.itemList"
                   :key="'keyU'+index1"
                >{{item1.name +':'+item1.value}}</p>
              </span>

            </tip>
            <!--              <Tooltip style="width: 100%;height: 100%">-->
            <!--                <Icon type="ios-arrow-down"></Icon>-->
            <!--                <div slot="content">-->
            <!--                  <p>Display multiple lines of information</p>-->
            <!--                  <p><i>Can customize the style</i></p>-->
            <!--                </div>-->
            <!--              </Tooltip>-->
          </div>
        </div>

      </div>

    </section>

    <section v-if="pageData&&pageData.secondLine" class="line mb16" >
      <ul class="flex" >
        <li v-for="(item,index) in pageData.secondLine" style="width: 150px;">
          <div>{{item.name}}</div>
          <div class="color-main">{{item.value}}</div>


        </li>
      </ul>

    </section>

    <section class="line" v-if="pageData&&pageData.thirdLine" >
      <div>
        <ul>
          <li class="line3-item" v-for="(item,index) in pageData.thirdLine" :key="'keyK'+index">
            <div class="block">{{item.name}}</div>
            <div class="color-main block">{{item.value}}</div>
            <div class="block">
              <span v-if="item.desc">{{item.desc}}</span>
              <span class="icon" v-if="item.itemList && item.itemList.length">
               <tip>
                 <div>
                   <p v-for="(item1,index1) in item.itemList">{{item1.name+':'+item1.value}}</p>
                 </div>

               </tip>
            </span>

            </div>

          </li>
        </ul>
      </div>

    </section>


  </div>
</template>

<script>
  import Tip from './Tip'

  export default {
    name: "Info",
    components: {
      Tip
    },
    props: {
      pageData: {
        type: Object,
        default: null
      }

    },

  }
</script>

<style scoped>
.two{
  min-width: 900px;
  /* height: 250px; */
  flex-wrap: wrap;
}
  .line {
    font-size: 18px;
    font-weight: bold;
  }

  .item {
    /* min-width: 300px; */
    width: 33%;
    margin-bottom: 40px;
    /*background-color: rgb(220, 220, 220);*/
    font-size: 24px;
    font-weight: bold;
  }

  .top {
    width: 100%;
    display: flex;
    align-items: center;
    line-height: 52px;
  }

  .text {
    margin-right: 5px;
  }

  .icon {
    text-align: center;
    width: 20px;
    display: inline-block;
    /*height: 40px;*/

  }

  .value {
    /*margin-top: -10px;*/
    width: 100%;
    display: flex;
    align-items: center;
  }

  .line3-item{
    line-height: 2;
    /*width: 25%;*/
  }
  .block {
    width: 25%;
    display: inline-block;
  }

  .infowrapper {
    /*background-color: rgba(220, 220, 220, .3);*/
    /* border-bottom: 1px solid  rgba(220, 220, 220, .8); */
    border-top: 1px solid  rgba(220, 220, 220, .8);

    padding: 15px 20px 20px 20px;
    min-height: 150px;
    /*max-height: 400px;*/
    /*overflow: scroll;*/
  }

  .mt-10 {
    margin-top: -9px;
  }
</style>
